export function createSessionId() {
    return crypto.randomUUID ? crypto.randomUUID() : `sess_${Math.random().toString(36).slice(2)}`;
}
export function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
